/* cspell:disable-next-line */
export const SITE_NAME = `${process.env.REACT_APP_SITE_NAME ?? ''}`;
export const BASE_URL = `${process.env.REACT_APP_BASE_URL ?? ''}`;
export const APP_VERSION = '0.0.1-alpha';

export const SITE_URLS = {
    // authentication routes
    selectAccountType: 'select-account-type',
    createAccount: 'register',
    createDriverAccount: 'register-driver-account',
    login: 'login',
    recoverPassword: 'recover-password',
    validateRecoveryToken: 'recover-password/token',
    pageNotFound: 'notfound',
    // rider routes
    userProfileRider: 'my-profile-rider',
    editRiderProfile: 'my-profile-rider/edit',
    mapRider: 'map/rider',
    // driver routes
    userProfileDriver: 'my-profile-driver',
    editDriverProfile: 'my-profile-driver/edit',
    createVehicle: 'my-profile/vehicle/create',
    editVehicle: 'my-profile/vehicle/edit',
    myVehicles: 'my-profile/vehicle/list',
    mapDriver: 'map/driver',
    editDocuments: 'my-profile/driver-documents-details',
    // shared routes
    termsConditions: 'terms-and-conditions',
    privacyPolicy: 'privacy-policy',
    myProfile: 'my-profile',
    editProfile: 'my-profile/edit',
    map: 'map',
    // multistep routes
    personal: 'personal',
    otp: 'otp',
    password: 'password',
    documents: 'documents',
    welcome: 'welcome',
    car: 'car',
};

export const PASSWORD_MIN_LENGTH = 8;
export const REGEX_HAS_UPPERCASE = /[A-Z]/;
export const REGEX_HAS_LOWERCASE = /[a-z]/;
export const REGEX_HAS_DIGIT = /\d/;
export const REGEX_HAS_SPECIAL_CHAR = /\W/;
export const REGEX_IS_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
export const MAX_IMAGE_SIZE_MB = 5; // max size in MB
export const MAX_SHARE_LOCATION_HOURS = 4;

export const NOTIFICATIONS_DISMISS_SECONDS = 5;

export const LANGUAGES = [{ code: 'pt' }, { code: 'en' }] as const;
export type Language = (typeof LANGUAGES)[number]['code'];

// local storage keys

export const API_VERSION = '/api/v1';
export const API_URL = `${process.env.REACT_APP_API_URL ?? 'http://192.168.1.192'}${API_VERSION}`;
